import { InputContainer, InputLabel } from "@sellar-io/components";
import type { ReactNode } from "react";

export const FormField = ({
  label,
  errorMessage,
  containerClassName,
  children,
}: {
  label: string;
  errorMessage: string | undefined;
  containerClassName?: string;
  children: ReactNode;
}) => (
  <div className="flex flex-col gap-1">
    <InputLabel>{label}</InputLabel>
    <InputContainer className={containerClassName}>{children}</InputContainer>
    {errorMessage && (
      <span role="alert" className="text-sm text-red-700">
        {errorMessage}
      </span>
    )}
  </div>
);
